import { ConstantValues } from "../Constants/ConstantValues";
import { Gender } from "../Constants/Gender";
import { CodeValue } from "./CodeValue";
import { RvqPractitionerPreference } from "./RvqPractitionerPreference";

class PractitionerModel {
    public Id: number;
    public GivenName: string;
    public FamilyName: string;
    public Gender: Gender;
    public PermitNumber: string;
    public Roles: CodeValue[];
    public IsActive: boolean;

    public constructor(init?: Partial<PractitionerModel>) {
        Object.assign(this, init);
    }

    public static toPreference(model: PractitionerModel): RvqPractitionerPreference {
        return new RvqPractitionerPreference({
            DisplayName: this.getDisplayName(model),
            QuebecVaccinationRegistryId: model.Id,
            GivenName: model.GivenName,
            FamilyName: model.FamilyName,
            PermitNumber: model.PermitNumber,
            Gender: model.Gender,
            RolesCode: model.Roles,
            IsActive: model.IsActive
        });
    }

    public static getDisplayName(model: PractitionerModel): string {
        if (model.Id === ConstantValues.PractitionerUnknownId)
            return cacheStore.GetString("UnknownLabel");

        const roles = model.Roles?.map(x => x.Label).join(", ") ?? "";
        let str = `${model.GivenName} ${model.FamilyName}`;
        if (model?.PermitNumber)
            str += ` - ${model.PermitNumber}`;
        str += ` (${roles})`;
        str += " - " + cacheStore.GetString(model.IsActive ? "ActiveLabel" : "InactiveLabel");

        return str;
    }
}

export { PractitionerModel };
